import assignmentBlue from '@images/home/assignment-blue.png'
import Component from '@glimmer/component'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { array } from '@ember/helper'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

export class HomeTilesManageAssignmentsReading extends Component {
  get assignmentBluePng() {
    return assignmentBlue
  }

  <template>
    <HomeTile @themeKey={{themeKey "reading"}} @title={{t "pages.home.panels.manageAssignments.title"}}>
      <div class="space-y-3 bg-white p-3">
        <div class="flex h-28 items-start">
          <img class="mr-6" src={{this.assignmentBluePng}} alt={{t "pages.home.panels.manageAssignments.imageAlt"}} />
          <p class="mb-3">{{t "pages.home.panels.manageAssignments.description"}}</p>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="assignments.product.manage.current"
            @models={{array "reading-eggs"}}
            @appearance={{ButtonAppearance.regular}}
          >
            {{t "products.re"}}
            {{t "pages.home.panels.manageAssignments.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="assignments.product.manage.current"
            @models={{array "reading-eggspress"}}
            @appearance={{ButtonAppearance.regular}}
          >
            {{t "products.rex"}}
            {{t "pages.home.panels.manageAssignments.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="assignments.product.manage.current"
            @models={{array "fast-phonics"}}
            @appearance={{ButtonAppearance.regular}}
          >
            {{t "products.fp"}}
            {{t "pages.home.panels.manageAssignments.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
      </div>
    </HomeTile>
  </template>
}

export default HomeTilesManageAssignmentsReading
